import { useQuery } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';
import { useSession } from '@sdk/session/SessionContext';
import { usePersonaCollection } from '@sdk/personaCollection/PersonaCollectionContext';

import { getLikedByByQueryKey } from '@web/newsfeed/utils/getQueryKey';
import { getPersonasListFromApi } from '@web/common/utils/getPersonasListFromApi';

type Props = {
  pageId: ID;
  articleId: ID;
  commentId?: ID;
  likedByCount: number;
};

export const useLikedBy = ({ pageId, articleId, likedByCount, commentId = null }: Props) => {
  const { currentUser } = useSession();
  const personaCollection = usePersonaCollection();
  const { newsfeed, newsfeedComments } = useSlingApi();
  const queryKey = getLikedByByQueryKey(pageId, articleId, likedByCount, commentId);

  const result = useQuery({
    queryKey,
    queryFn: async () => {
      const { data } =
        commentId === null
          ? await newsfeed.getLikedBy(pageId, articleId)
          : await newsfeedComments.getLikedBy(pageId, articleId, commentId);

      return getPersonasListFromApi(data, personaCollection, currentUser);
    },

    refetchOnMount: false,
  });

  return result;
};
